import { useQuery } from '@tanstack/react-query';

// default values
import { DEFAULT_QUERY_RETRY_COUNT } from '../../constants/react-query.constant';

// helpers
import { BaseError } from './../../helpers/BaseError';

// Models
import {
    AudienceEstimatorModel,
    AudienceCategoryModel,
} from '../../models/audience.model';
import { CreateFilterAttributeModel } from '../../models/contact_attributes.model';

// services
import API from '../../services/api';

// query keys
import audienceKeys from './_queryKeys';

const getAudience = async (
    filters: CreateFilterAttributeModel[],
    withCategories: boolean,
): Promise<AudienceEstimatorModel> => {
    const filter = filters.map((item) => ({
        attribute_id: item.attribute.value,
        operator_id: item.operator.value,
        value: ['string', 'number'].includes(typeof item.value)
            ? item.value
            : (item.value as any)?.label,
    }));

    const { data } = await API.getAudienceMetrics(filter, {
        with_categories: withCategories,
    });

    return {
        ...(data ?? {}),
        category: (data?.category ?? []).sort(
            (a: AudienceCategoryModel, b: AudienceCategoryModel) =>
                a.order - b.order,
        ),
    };
};

export default function useAudienceMainQuery(
    filters: CreateFilterAttributeModel[],
    withCategories: boolean = true,
    disableRetry?: boolean,
) {
    return useQuery<AudienceEstimatorModel, BaseError>({
        queryKey: [...audienceKeys.audienceEstimate, filters, withCategories],
        queryFn: () => getAudience(filters, withCategories),
        staleTime: 1000 * 24 * 60 * 60,
        retry: disableRetry ? false : DEFAULT_QUERY_RETRY_COUNT,
    });
}
